import React from "react";
import PropTypes from "prop-types";
import ListPoint from "./ListPoint";

const CustomDecimalPoint = ({ point, index }) => (
	<div className="numbered-bullet-point">
		<span>{index + 1}.</span>
		<ListPoint
			desc={point}
			bulletPoints={false}
		/>
	</div>
);
CustomDecimalPoint.propTypes = {
	point: PropTypes.string,
	index: PropTypes.number
};

export default CustomDecimalPoint;
